import React from 'react';
import PropTypes from 'prop-types';
import styles from './RetailerInfo.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import RetailerImage from '../../common/RetailerImage';
import { fullName } from '../../../utils/textHelper';

function RetailerInfo(props) {
  const { id, website, admin_contact, square_logo_path, name } = props.retailer;
  const { email, phone } = admin_contact;

  return (
    <Container className={styles.singleRetailer} fluid>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <div className={styles.singleRetailerLogo}>
            <RetailerImage image={square_logo_path} name={name} size="200" />
          </div>
        </Col>

        <Col xs={6} md={8} lg={9} className={styles.singleRetailerInfo}>
          <div className={styles.singleRetailerName}>{name}</div>

          <div className={styles.status}>{props.status}</div>

          <div className={styles.singleRetailerContact}>
            <div>
              <label>Retailer ID:</label>
              <span>{id}</span>
            </div>

            <div>
              <label>Name:</label>
              <span>{fullName(admin_contact)}</span>
            </div>

            {website && (
              <div>
                <label>Website:</label>
                <span>
                  <a href={`https://${website}`} target="_blank" rel="noopener noreferrer">
                    {website}
                  </a>
                </span>
              </div>
            )}

            <div>
              <label>E-mail:</label>
              <span>
                <a href={`mailto:${email}`}>{email}</a>
              </span>
            </div>

            <div>
              <label>Phone:</label>
              <span>{phone}</span>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default RetailerInfo;

RetailerInfo.propTypes = {
  retailer: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    website: PropTypes.string,
    square_logo_path: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};
